module.exports = __webpack_public_path__ + "static/media/inhale.38b4b6a5.mp3";